<template>
	
  <div id="box-gallery" :class="['py-5 px-3', 'bk-'+ section]">
    <div class="container">

      <h2 class="text-center mb-5">
        Yacht <br v-if="section == 'ab-yachts'" class="d-sm-none">
        Gallery
      </h2>

      <div class="row justify-content-center text-center">

        <div v-if="pageItem.exteriors" :class="colClass" @click="openExteriorsGallery()">
          <div class="ratio ratio-16x9">
            <div class="previewGallery" :style="'background-image: url('+ pageItem.exteriors[0].src +')'"></div>
          </div>
          <h3 class="mt-4">Exteriors</h3>
        </div>

        <div v-if="pageItem.interiors" :class="colClass" @click="openInteriorsGallery()">
          <div class="ratio ratio-16x9">
            <div class="previewGallery" :style="'background-image: url('+ pageItem.interiors[0].src +')'"></div>
          </div>
          <h3 class="mt-4">Interiors</h3>
        </div>

        <div v-if="pageItem.videos" :class="colClass" @click="openVideoGallery()">
          <div class="ratio ratio-16x9">
            <div class="previewGallery" :style="'background-image: '+ ((pageItem.gallerycover) ? 'url('+ pageItem.gallerycover +')' : 'none') +''">
              <div class="play-video">
                <img :src="require('../assets/play-white.svg')" alt="Play video">
              </div>
            </div>
          </div>
          <h3 class="mt-4">Other videos</h3>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
	import { Fancybox } from "@fancyapps/ui";
	import "@fancyapps/ui/dist/fancybox/fancybox.css";
	
	export default {
		name: 'YachtGallery',
		props: ['section', 'pageItem'],
    data () {
      return {
        publicPath: process.env.BASE_URL,
      }
    },
    computed: {
      colClass() {
        let nGalleries = 0
        let colClass = ''
        if (this.pageItem.interiors) nGalleries++
        if (this.pageItem.exteriors) nGalleries++
        if (this.pageItem.videos) nGalleries++
        //console.log('getGallery => nGalleries', nGalleries)
        switch(nGalleries) {
          case 1:
            colClass = 'col-12 col-sm-8 link'
            break;
          case 2:
            colClass = 'col-12 col-sm-6 link'
            break;
          case 3:
            colClass = 'col-12 col-sm-4 link'
            break;
        }
        return colClass
      },
    },
		methods: {
			openInteriorsGallery() {
				Fancybox.show(this.pageItem.interiors);
			},
			openExteriorsGallery() {
				Fancybox.show(this.pageItem.exteriors);
			},
			openVideoGallery() {
        // offline fermo eventuale timeout screensaver
        if (global.isOffline) this.$store.dispatch('videos/playVideo')
				Fancybox.show(this.pageItem.videos, {
          on: {
            close: () => {
              if (global.isOffline) this.$store.dispatch('videos/closeVideo')
            },
          },
        });
			},
		},
	}
</script>

<style scoped>
.ab-yaches h3 {
  text-transform: uppercase;
}
.maiora h3 {
  text-transform: capitalize;
}
</style>
